module.exports = __webpack_public_path__ + "img/chc-logo.abd92334.png";